import { useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";
import Header from "src/components/layout/Header";

// 판매자 정보 타입 정의
type Seller = {
  provider: any; // 판매자 기본 정보
  providerContactList: any; // 판매자 연락처 목록
};

// 판매자 정보 모달 컴포넌트
// 판매자의 상세 정보를 표시하는 모달 컴포넌트
const SellerModal = () => {
  const { t } = useTranslation("contract");
  // 네비게이션 및 위치 정보
  const navigate = usePartnerNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sellerData = JSON.parse(decodeURIComponent(searchParams.get("data") || "{}"));

  // 모달 닫기 핸들러
  const onClose = () => {
    navigate(-1);
  };

  // 판매자 데이터 상태 관리
  const [modalData] = useState<Seller>(sellerData);

  // CS 담당자 연락처 정보 메모이제이션
  const pcl = useMemo(() => {
    let rtn: any = {};
    if (sellerData && sellerData.providerContactList) {
      const finded = sellerData.providerContactList.find((item: any) => item.assignedWorkType === "CS_PROVIDE");

      if (finded) {
        return finded;
      } else {
        return rtn;
      }
    }
  }, [sellerData]);

  return (
    <div className="modal-container">
      {/* 헤더 컴포넌트 */}
      <Header
        headerType="BACK"
        title={t("seller.title")}
        onClickBackButton={() => {
          onClose()!;
        }}
      />

      {/* 판매자 정보 섹션 */}
      <section className="base-section-layout w-100">
        <div className="base-section-layout__container">
          {/* 섹션 제목 */}
          <div className="base-section-layout__title-wrap">
            <h2>{t("seller.title")}</h2>
          </div>

          {/* 취소 규정 안내 */}
          <ul className="mb30 ml10 mr10 font15 text-primary1">
            <li>{t("seller.cancellationNotice1")}</li>
            <li>{t("seller.cancellationNotice2")}</li>
          </ul>

          {/* 판매자 상세 정보 테이블 */}
          <table className="horizontal-table font14">
            <tbody>
              <tr>
                <td className="minmax160">{t("seller.businessName")}</td>
                <td>{modalData?.provider?.providerName}</td>
              </tr>
              <tr>
                <td>{t("seller.representativeName")}</td>
                <td>{modalData?.provider?.representative}</td>
              </tr>
              <tr>
                <td>{t("seller.businessRegistrationNumber")}</td>
                <td>{modalData?.provider?.businessRegistrationNumber}</td>
              </tr>
              <tr>
                <td>{t("seller.address")}</td>
                <td>
                  <p className="ellipsis2">{modalData?.provider?.address}</p>
                </td>
              </tr>
              <tr>
                <td>{t("seller.contactNumber")}</td>
                <td>{pcl?.contact}</td>
              </tr>
              <tr>
                <td>{t("seller.email")}</td>
                <td>{pcl?.email}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default SellerModal;
